import { useState, type FormEvent } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { api, ApiError } from '../api';

/** D-23: single-use set-password link from the ready email: /set-password?token=… */
export function SetPasswordPage() {
  const [params] = useSearchParams();
  const token = params.get('token') ?? '';
  const navigate = useNavigate();
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  async function submit(e: FormEvent) {
    e.preventDefault();
    if (password !== confirm) return setError('The two passwords do not match.');
    if (password.length < 10) return setError('Use at least 10 characters, including a number.');
    setBusy(true);
    setError(null);
    try {
      const r = await api.setPassword(token, password);
      navigate('/login', { state: { email: r.email, notice: 'Password set. Sign in to continue.' } });
    } catch (err) {
      setError(err instanceof ApiError ? err.message : String(err));
    } finally {
      setBusy(false);
    }
  }

  if (!token) {
    return (
      <div style={{ maxWidth: 440 }}>
        <h1>Set your password</h1>
        <p className="muted" style={{ marginTop: 12 }}>
          This page needs the link from your email. If it has expired, use “Forgot password” on the sign-in page.
        </p>
      </div>
    );
  }
  return (
    <div style={{ maxWidth: 440 }}>
      <h1>Set your password</h1>
      <p className="muted small" style={{ marginTop: 8 }}>
        Choose the password for your console account. At least 10 characters with a number.
      </p>
      <form className="card grid" style={{ gap: 12, marginTop: 20 }} onSubmit={submit}>
        <label className="field">
          New password
          <input className="input" type="password" autoComplete="new-password" value={password} onChange={(e) => setPassword(e.target.value)} required minLength={10} />
        </label>
        <label className="field">
          Repeat password
          <input className="input" type="password" autoComplete="new-password" value={confirm} onChange={(e) => setConfirm(e.target.value)} required minLength={10} />
        </label>
        {error && <p className="badge bad">{error}</p>}
        <div>
          <button className="btn primary" disabled={busy}>
            {busy ? 'Saving…' : 'Set password and continue'}
          </button>
        </div>
      </form>
    </div>
  );
}
